import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import styled from "styled-components";

import { Box, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";

import Typography from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

const CardComponent = (props) => {
  const { cardRef, openPaymentPage = () => {} } = props || {};
  const slider = useRef(null);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: `${props?.planData?.length || 4}.15`,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: `${props?.planData?.length || 4}.15`,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
        },
      },
    ],
  };
  useEffect(() => {
    let sliders = slider;
    setTimeout(() => {
      if (sliders.current) {
        sliders.current.slickGoTo(0);
      }
    }, 2000);
  }, []);
  return (
    <FlexDiv py={"40px"} flexDirection="column" ref={cardRef}>
      <FlexContainer flexDirection="column" alignItems={"center"}>
        <Heading
          textAlign={"center"}
          variant="heading2"
          color={theme.colors.link2Color}
        >
          All packages
        </Heading>
        <FlexDiv width={"100%"} flexDirection="column">
          <SlideWrap mx={"-10px"}>
            <Slider ref={slider} {...settings}>
              {props?.planData?.length &&
                props?.planData?.map((item, index) => {
                  return (
                    <CardBody
                      flexDirection={"column"}
                      alignItems={"flex-start"}
                      key={index}
                    >
                      <TopBox>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.title}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.price_text}
                          </Typography>
                        </Box>
                      </TopBox>
                      <UL>
                        {item?.feature_list.map((list, i) => {
                          const text = { __html: list };
                          let string = list;
                          let substring = 'class="gold"';
                          return (
                            <LI
                              key={i}
                              disablebullet={string.includes(substring)}
                            >
                              <Typography
                                variant="paragraph2"
                                color={theme.colors.white}
                                dangerouslySetInnerHTML={text}
                              />
                            </LI>
                          );
                        })}
                      </UL>

                      {item?.button_cta && (
                        <Button
                          variant={"primary1"}
                          bgColor={theme.colors.white}
                          hoverColor={theme.colors.white}
                          TextColor={theme.colors.gray_100}
                          onClick={() => openPaymentPage(item)}
                          fontSize={"11px"}
                          fontFamily={"var(--font-700)"}
                          btnPadding={"3.4px 24px"}
                          mt={"15px"}
                        >
                          {item?.button_cta}
                        </Button>
                      )}
                    </CardBody>
                  );
                })}
            </Slider>
          </SlideWrap>
        </FlexDiv>
      </FlexContainer>
    </FlexDiv>
  );
};
export default CardComponent;
const Heading = styled(Typography)`
  margin-bottom: 25px;
`;
const CardBody = styled(FlexDiv)`
  background-color: ${theme.colors.cardFallbackBg};
  background-image: ${theme.colors.cardGradient};
  border-radius: 10px;
  padding: 30px;
  outline: 0;
  display: flex !important;
  flex-direction: column;
`;
const TopBox = styled(Box)`
  position: relative;
  padding-bottom: 15px;
  margin-bottom: 10px;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    height: 5px;
    border-radius: 10px;
    background-color: ${theme.colors.white};
    width: 30px;
    bottom: 0;
  }
`;
const SlideWrap = styled(FlexDiv)`
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: auto !important;
  }
  .slick-slider {
    width: 100%;
    .slick-dots {
      li {
        &.slick-active {
          button {
            &::before {
              background-color: ${theme.colors.dotsColor};
            }
          }
        }
        button {
          position: relative;
          &::before {
            background-color: rgba(92, 92, 110, 0.2);
            border-radius: 50%;
            height: 8px;
            width: 8px;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
    .slick-slide {
      & > div {
        display: flex;
        height: 100%;
        margin: 0 4.5px;
        padding: 15px 7.5px;
        @media only screen and (max-width: 767px) {
          margin: 0;
          padding: 15px;
        }
        @media only screen and (max-width: 767px) {
          padding: 15px 10px;
        }
      }
    }
  }
`;
const UL = styled.ul`
  padding: 0;
  margin: 0;
  flex: 1;
`;
const LI = styled.li`
  margin-bottom: 4px;
  position: relative;
  list-style: none;
  ${({ disablebullet }) =>
    !disablebullet &&
    `
  padding-left: 10px;
  &:before {
    content: "";
    height: 3px;
    width: 3px;
    background-color: ${theme.colors.white};
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 10px;
    left: 0;
  }
  `};
  &:last-child {
    margin-bottom: 0;
  }
  .gold {
    color: ${theme.colors.yellow2};
    font-family: var(--font-700);
    font-size: inherit;
  }
  b {
    color: inherit;
    font-family: var(--font-700);
    font-size: inherit;
  }
`;
